import type { User } from 'firebase/auth';

/**
 * The parts of the signed-in account the UI reacts to. Snapshotted into
 * `authStore` because Firebase's `user.reload()` mutates the `User` in place,
 * which a store subscriber would never notice.
 */
export interface AuthSessionInfo {
    uid: string;
    /** No sign-in method linked yet (issue #332) — see {@link isGuestUser}. */
    isGuest: boolean;
    emailVerified: boolean;
    usesPassword: boolean;
    email: string | null;
}

/**
 * A guest has no sign-in method linked. That covers anonymous sign-ins and
 * guests who came back with their guest ID, which Firebase signs in through
 * a custom token and so does not flag as anonymous.
 */
export function isGuestUser(user: Pick<User, 'isAnonymous' | 'providerData'>): boolean {
    return user.isAnonymous || user.providerData.length === 0;
}

export function describeSession(
    user: Pick<User, 'uid' | 'isAnonymous' | 'emailVerified' | 'email' | 'providerData'>,
): AuthSessionInfo {
    return {
        uid: user.uid,
        isGuest: isGuestUser(user),
        emailVerified: user.emailVerified,
        usesPassword: user.providerData.some((info) => info.providerId === 'password'),
        email: user.email,
    };
}
